var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _setup.show
    ? _c("SoliResponsiveDialog", {
        attrs: {
          titleClasses: ["pt-1"],
          subtitle: _vm.contact.relation
            ? `${_vm.contact.relation}: ${_vm.contact.name}`
            : null,
        },
        on: {
          reset: function ($event) {
            return _setup.handleReset()
          },
        },
        scopedSlots: _vm._u(
          [
            {
              key: "title",
              fn: function () {
                return [
                  _c(
                    _setup.Link,
                    { attrs: { href: `/profile/${_vm.contact.id}/account` } },
                    [
                      _vm._v(
                        "\n            " +
                          _vm._s(_vm.title ?? _vm.contact.name) +
                          "\n        "
                      ),
                    ]
                  ),
                ]
              },
              proxy: true,
            },
            {
              key: "body",
              fn: function () {
                return [
                  _c("v-divider"),
                  _vm._v(" "),
                  _c(
                    "v-card-actions",
                    { staticClass: "justify-space-around mb-3" },
                    [
                      _c(
                        "v-btn",
                        {
                          attrs: {
                            icon: "",
                            href: _vm.route("conversation.search", {
                              recipients: [
                                {
                                  messagable_id: _vm.contact.id,
                                  messagable_type: "App\\Models\\User",
                                },
                              ],
                              channel: "chat",
                            }),
                          },
                        },
                        [
                          _c("v-icon", { attrs: { color: "dark" } }, [
                            _vm._v("chat_bubble_outline"),
                          ]),
                          _vm._v(" "),
                          _c(
                            "small",
                            {
                              staticClass: "mt-1 panel-text",
                              staticStyle: { "text-transform": "none" },
                            },
                            [_vm._v("Message")]
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-btn",
                        {
                          attrs: {
                            disabled: !_vm.contact.phone,
                            icon: "",
                            href: "tel:" + _vm.contact.phone,
                          },
                        },
                        [
                          _c("v-icon", { attrs: { color: "dark" } }, [
                            _vm._v("phone"),
                          ]),
                          _vm._v(" "),
                          _c(
                            "small",
                            {
                              staticClass: "mt-1 panel-text",
                              staticStyle: { "text-transform": "none" },
                            },
                            [_vm._v("Call")]
                          ),
                        ],
                        1
                      ),
                      _c(
                        "v-btn",
                        {
                          attrs: {
                            disabled: !_vm.contact.phone,
                            icon: "",
                            href: "sms:" + _vm.contact.phone,
                          },
                        },
                        [
                          _c("v-icon", { attrs: { color: "dark" } }, [
                            _vm._v("sms"),
                          ]),
                          _vm._v(" "),
                          _c(
                            "small",
                            {
                              staticClass: "mt-1 panel-text",
                              staticStyle: { "text-transform": "none" },
                            },
                            [_vm._v("Text")]
                          ),
                        ],
                        1
                      ),
                      _c(
                        "v-btn",
                        {
                          attrs: {
                            icon: "",
                            href: "mailto:" + _vm.contact.email,
                          },
                        },
                        [
                          _c("v-icon", { attrs: { color: "dark" } }, [
                            _vm._v("email"),
                          ]),
                          _vm._v(" "),
                          _c(
                            "small",
                            {
                              staticClass: "mt-1 panel-text",
                              staticStyle: { "text-transform": "none" },
                            },
                            [_vm._v("Email")]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("v-divider"),
                  _vm._v(" "),
                  _c(
                    "v-list",
                    { attrs: { dense: "" } },
                    [
                      _c(
                        "v-list-item",
                        [
                          _c(
                            "v-icon",
                            { staticClass: "mr-3", attrs: { color: "dark" } },
                            [_vm._v("phone")]
                          ),
                          _vm._v(_vm._s(_vm.contact.phone)),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-list-item",
                        [
                          _c(
                            "v-icon",
                            { staticClass: "mr-3", attrs: { color: "dark" } },
                            [_vm._v("email")]
                          ),
                          _vm._v(_vm._s(_vm.contact.email)),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ]
              },
              proxy: true,
            },
          ],
          null,
          false,
          2867555182
        ),
      })
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }